module.exports = __webpack_public_path__ + "static/media/chevron-double-left.44ce5c4f.svg";